import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  loginError: false,
  loginSuccess: false,
  loginProcess: false,
  user: {},
  tenant: {},
  token: null,
  refreshToken: null,

  registerError: false,
  registerSuccess: false,
  registerProcess: false,

  fetch_process: false,
  fetch_error: false,
  fetch_success: false,

  patch_process: false,
  patch_error: false,
  patch_success: false,

  reset_password_process: false,
  reset_password_error: false,
  reset_password_success: false,

  forgot_password_process: false,
  forgot_password_error: false,
  forgot_password_success: false,

  reinit_password_process: false,
  reinit_password_error: false,
  reinit_password_success: false,
};

const authReducer = handleActions({
  [types.LOGIN_PROCESS]: (state, { payload }) => {
    return {
      ...state,
      loginError: false,
      loginSuccess: false,
      loginProcess: true,
    }
  },
  [types.LOGIN_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loginError: false,
      loginSuccess: true,
      loginProcess: false,
      user: payload.user,
      tenant: payload.tenant,
      token: payload.token,
      refreshToken: payload.refreshToken,
    }
  },
  [types.LOGIN_ERROR]: (state, { payload }) => {
    return {
      ...state,
      loginError: true,
      loginSuccess: false,
      loginProcess: false,
      user: {}
    }
  },

  [types.REGISTER_PROCESS]: (state, { payload }) => {
    return {
      ...state,
      registerError: false,
      registerSuccess: false,
      registerProcess: true,
    }
  },
  [types.REGISTER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      registerError: false,
      registerSuccess: true,
      registerProcess: false,
      user: payload.user,
      token: payload.token,
      refreshToken: payload.refreshToken,
    }
  },
  [types.REGISTER_ERROR]: (state, { payload }) => {
    return {
      ...state,
      registerError: true,
      registerSuccess: false,
      registerProcess: false,
      user: {}
    }
  },

  [types.LOGOUT]: (state, { payload }) => {
    return initialState;
  },

  // FETCH USER
  [types.FETCH_USER_PROCESS]: (state) => {
    return {
      ...state,
      fetch_process: true,
      fetch_error: false,
      fetch_success: false,
    }
  },
  [types.FETCH_USER_ERROR]: (state) => {
    return {
      ...state,
      fetch_process: false,
      fetch_error: true,
      fetch_success: false,
    }
  },
  [types.FETCH_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetch_process: false,
      fetch_error: false,
      fetch_success: true,
      user: payload
    }
  },

  // PATCH USER
  [types.PATCH_USER_PROCESS]: (state) => {
    return {
      ...state,
      patch_process: true,
      patch_error: false,
      patch_success: false,
    }
  },
  [types.PATCH_USER_ERROR]: (state) => {
    return {
      ...state,
      patch_process: false,
      patch_error: true,
      patch_success: false,
    }
  },
  [types.PATCH_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      patch_process: false,
      patch_error: false,
      patch_success: true,
    }
  },

  // RESET PASSWORD
  [types.RESET_PASSWORD_PROCESS]: (state) => {
    return {
      ...state,
      reset_password_process: true,
      reset_password_error: false,
      reset_password_success: false,
    }
  },
  [types.RESET_PASSWORD_ERROR]: (state) => {
    return {
      ...state,
      reset_password_process: false,
      reset_password_error: true,
      reset_password_success: false,
    }
  },
  [types.RESET_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      reset_password_process: false,
      reset_password_error: false,
      reset_password_success: true,
    }
  },

  // FORGOT PASSWORD
  [types.FORGOT_PASSWORD_PROCESS]: (state) => {
    return {
      ...state,
      forgot_password_process: true,
      forgot_password_error: false,
      forgot_password_success: false,
    }
  },
  [types.FORGOT_PASSWORD_ERROR]: (state) => {
    return {
      ...state,
      forgot_password_process: false,
      forgot_password_error: true,
      forgot_password_success: false,
    }
  },
  [types.FORGOT_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      forgot_password_process: false,
      forgot_password_error: false,
      forgot_password_success: true,
    }
  },

  // REINIT PASSWORD
  [types.REINIT_PASSWORD_PROCESS]: (state) => {
    return {
      ...state,
      reinit_password_process: true,
      reinit_password_error: false,
      reinit_password_success: false,
    }
  },
  [types.REINIT_PASSWORD_ERROR]: (state) => {
    return {
      ...state,
      reinit_password_process: false,
      reinit_password_error: true,
      reinit_password_success: false,
    }
  },
  [types.REINIT_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      reinit_password_process: false,
      reinit_password_error: false,
      reinit_password_success: true,
    }
  },
  [types.REFRESH_TOKEN]: (state, { payload }) => {
    return {
      ...state,
      token: payload.token
    }
  },
}, initialState);

export default authReducer;
